export default "__VITE_ASSET__DlBkbYzk__"